"use client";

import type { ToastApi } from "@dionatanbig2be/big2be-ui";

/**
 * Ponte global para o ToastProvider do big2be-ui. O `useToast` da lib é um
 * hook — só funciona dentro de componente. Este módulo guarda a instância
 * viva da api (setada pelo ToastBridge, montado dentro do UIProviders) para
 * que stores zustand, services e handlers fora de React continuem podendo
 * disparar `toast.success(...)` como faziam com o sonner.
 */
// `neutral` opcional: só existe a partir do big2be-ui 2.9.5 — com uma lib
// mais antiga instalada cai em `success` em vez de quebrar o build.
type BridgedToastApi = ToastApi & { neutral?: (message: string) => void };

let api: BridgedToastApi | null = null;

export function __setToastApi(next: ToastApi | null) {
    api = next;
}

/** Forma chamável (`toast("...")`, herdada do sonner) = sucesso. */
export const toast = Object.assign((message: string) => api?.success(message), {
    success: (message: string) => api?.success(message),
    error: (message: string) => api?.error(message),
    info: (message: string) => api?.info(message),
    warning: (message: string) => api?.warning(message),
    /** Confirmação discreta (cor neutra do tema) — ex.: item adicionado ao carrinho. */
    neutral: (message: string) => (api?.neutral ?? api?.success)?.(message),
});
